import React from 'react';

const OrderConfirmation = ({ order, onClose, onClearCart }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">¡Compra Exitosa!</h2>
          <p className="text-gray-600 mb-6">
            Tu orden ha sido procesada correctamente. Te contactaremos pronto para coordinar la entrega.
          </p>
          
          <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
            <h3 className="font-medium text-gray-900 mb-3">Detalles de tu orden</h3>
            <div className="space-y-2 text-sm">
              <div>
                <span className="text-gray-600">Orden #:</span>
                <span className="font-medium ml-2">{order.id}</span>
              </div>
              <div>
                <span className="text-gray-600">Cliente:</span>
                <span className="font-medium ml-2">{order.customer.name} {order.customer.lastName}</span>
              </div>
              <div>
                <span className="text-gray-600">Total:</span>
                <span className="font-medium ml-2">${order.total.toLocaleString('es-AR')}</span>
              </div>
              <div>
                <span className="text-gray-600">Productos:</span>
                <div className="ml-2 mt-1">
                  {order.items.map((item, index) => (
                    <div key={index} className="text-gray-600">
                      • {item.name} {item.selectedColor && `(${item.selectedColor})`} x{item.quantity}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          <button
            onClick={() => {
              if (onClearCart) {
                onClearCart();
              }
              onClose();
            }}
            className="w-full py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
          >
            Continuar Comprando
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation; 